// global
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { TransitionGroup, CSSTransition } from 'react-transition-group';
// local
import './Snackbar.css';
// actions
import { dismissSnackbar, dismissLast } from 'app/redux/actions/snackbar';

const DURATION = 400; // 400 ms
const SNACKBAR_TIMEOUT = 5000; // 10 seg

class Snackbar extends Component {
    componentDidUpdate() {
        const { messages } = this.props.snackbar;
        this.clearT();
        // if there is a message to be displayed
        if (messages.length > 0) {
            this.startT();
        }
    }

    startT() {
        this.timeout = setTimeout(() => this.dismissLast(), SNACKBAR_TIMEOUT);
    }

    clearT() {
        if (this.timeout) {
            clearTimeout(this.timeout);
        }
    }

    dismissLast = () => this.props.dispatch(dismissLast());

    handleDismiss = id => () => this.props.dispatch(dismissSnackbar(id));

    render() {
        const { messages } = this.props.snackbar;
        return (
            <TransitionGroup className="snackbar-list">
                {messages.map(message => {
                    return (
                        <CSSTransition key={message.id} timeout={DURATION} classNames="snackbar">
                            <div className="snackbar">
                                <div className="message">{message.title}</div>
                                {message.action && !message.error ? 
                                    (<div className="action ok" onClick={this.handleDismiss(message.id)}>
                                        OK
                                    </div>)
                                    :
                                    (<div className="action error" onClick={this.handleDismiss(message.id)}>
                                        ERROR
                                    </div>)
                                }
                            </div>
                        </CSSTransition>
                    );
                })}
            </TransitionGroup>
        );
    }
}

Snackbar.propTypes = {
    dispatch: PropTypes.func,
    snackbar: PropTypes.object,
};

const mapStateToProps = state => ({
    snackbar: state.snackbar,
});
export default connect(mapStateToProps)(Snackbar);
